
import React from "react";
import { convertAdUrl } from "../../utils/utils";
import { useSelector } from "react-redux";

const ContinueWatchingModel = (props) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const ContinueWatchingHandler = async (value) => {
    if (value === "yes") {
      // if(projectInfo?.projectConfig?.config?.AD_REQUIRED === "true"){
      //   props?.setAdUrl(convertAdUrl(props?.videoDetails,props?.showDetails,props?.appInfo))
      // }
      props?.setIsContinueWatchingModal(false);
      
      props?.playVideo(
        props?.videoDetails?.watched_duration
      );
  
    } else if (value === "no") {
      // if(projectInfo?.projectConfig?.config?.AD_REQUIRED === "true"){
      //   props?.setAdUrl(convertAdUrl(props?.videoDetails,props?.showDetails,props?.appInfo))
      // }

      props?.setIsContinueWatchingModal(false);

      props?.playVideo(0);
    }
  };
  return (
    <div className="countinueWatching">
      <div className="overlayModal"></div>
      <div className="contents">
        <h1>Continue from where you stopped?</h1>
        <div className="buttons">
          <div
            className="buttonContainer"
            onClick={() => ContinueWatchingHandler("yes")}
          >
            <div className="background"></div>
            <button>Yes</button>
          </div>

          <div
            className="buttonContainer"
            onClick={() => ContinueWatchingHandler("no")}
          >
            <div className="background"></div>
            <button>No</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContinueWatchingModel;
